import { Clinic } from './../layouts/private-layout/pages/clinic/services/clinic.model';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpService } from './http.service';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { SharedService } from './shared.service';
import { ClinicsService } from '../layouts/private-layout/pages/clinic/services/clinics.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  ClinicList: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor(private apiService: HttpService, private sharedService: SharedService, private clinicService: ClinicsService) {}

  /* Clinincs API */
  public GetClinics() {
    if (this.sharedService.IsAdminUser.value) {
      this.apiService.getData('Clinic/Clinics').subscribe({
        next: (res: any) => {
          this.ClinicList.next(res.result);
        }
      });
    } else {
      const res = this.clinicService.GetClinic(this.sharedService.CurrentClinic.value || 0);
      res.subscribe({
        next: (res: any) => {
          const { isDeleted, ...rest } = res.result;
          this.ClinicList.next([rest]);
        },
        complete: () => {}
      });
    }
  }

  public GetClinicName(id: number): string {
    let clinicName = 'Assigned all clinics';
    if (id && this.ClinicList.value) {
      this.ClinicList.subscribe((clinics) => (clinicName = clinics.filter((clinic: Clinic) => clinic.id === id)[0].clinicName));
    }

    return clinicName;
  }

  /* GET MRI Facility API */
  GetMRIFacilities(clinicId: number): Observable<any> {
    return this.apiService.getData(`MRIFacility/MRIFacilies?clinicId=${clinicId}`);
  }
}
